import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import blogs from "../data";
import Container from "@mui/material/Container";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

const Blog = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const { id } = useParams();
  const blog = blogs.find((doc) => doc.id === parseInt(id));

  if (!blog) return <div>Blog not found</div>;

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Link to="/blogs">
        <Button variant="outlined" startIcon={<FaArrowLeftLong />} sx={{ mb: 3 }}>
          Back
        </Button>
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Card elevation={6} sx={{ borderRadius: 3 }}>
          <CardMedia
            component="img"
            height="350"
            image={blog.image}
            alt={blog.name}
            sx={{ objectFit: "cover" }}
          />

          <CardContent sx={{ px: 4, py: 3 }}>
            <Typography variant="h4" component="h1" gutterBottom>
              {blog.name}
            </Typography>

            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              By {blog.author || "Unknown Author"} • {blog.date || "Today"}
            </Typography>

            <Typography
              variant="body1"
              color="text.primary"
              sx={{ mt: 2, lineHeight: 1.8 }}
            >
              {blog.desp}
            </Typography>
          </CardContent>
        </Card>
      </motion.div>
    </Container>
  );
};

export default Blog;
